var exports = {
  "k": "xe533113f--cea2c1--container",
};

module.exports = exports;
